export const INTERVALS = {
    hour: 60,
    day: 1440
};

export const DATE_CONSTANTS = {
    secondsInDay: 86400
};

export const FIRST_TIMESTAMP = 1735689600; //01.01.2025

export function getMinusWeekTimestamp() {
    const date = getEndOfDay();
    date.setDate(date.getDate() - 7);
    return toSecondsTimestamp(date.getTime());
}

export function getMinusMonthTimestamp() {
    const date = getEndOfDay();
    date.setDate(date.getDate() - 31);
    return toSecondsTimestamp(date.getTime());
}

export function getMinusYearTimestamp() {
    const date = getEndOfDay();
    date.setFullYear(date.getFullYear() - 1);
    return toSecondsTimestamp(date.getTime());
}

export function getTodayEndTimestamp() {
    return toSecondsTimestamp(getEndOfDay());
}

export function getEndOfDay() {
    const endOfDay = new Date();
    endOfDay.setHours(23, 59, 59, 999);
    return endOfDay;
}

export function toSecondsTimestamp(millisecondsTimestamp) {
    return Math.floor(millisecondsTimestamp / 1000);
}

export function getDateByTimestamp(secondsTimestamp) {
    return new Date(secondsTimestamp * 1000);
}

const weekDaysNames = [
    "Niedziela",
    "Poniedziałek",
    "Wtorek",
    "Środa",
    "Czwartek",
    "Piątek",
    "Sobota"
];

export function getWeekDayName(secondsTimestamp) {
    const date = getDateByTimestamp(secondsTimestamp);
    return weekDaysNames[date.getDay()];
}

/* date in two lines, example:
11 lis.
 2026
*/
export function getEachExactDayNumberDate(date, dayNumber) {
    return date.getDate() === dayNumber
        ? [formatDayNumberWithMonthName(date), date.getFullYear()]
        : null;
}

const monthsNamesPrefixes = [
    "sty.",
    "lut.",
    "mar.",
    "kwi.",
    "maj",
    "cze.",
    "lip.",
    "sie.",
    "wrz.",
    "paź.",
    "lis.",
    "gru."
];

export function formatDayNumberWithMonthName(date) {
    return date.getDate() + ' ' + monthsNamesPrefixes[date.getMonth()]; //example: 11 lis.
}

const timeAndDateFormatOptions = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
}

export function formatTooltipDate(date) {
    const formatter = new Intl.DateTimeFormat('pl-PL', timeAndDateFormatOptions)

    const parts = formatter.formatToParts(date);
    const day = parts.find(part => part.type === 'day').value;
    const month = parts.find(part => part.type === 'month').value.toUpperCase();
    const year = parts.find(part => part.type === 'year').value;
    const hour = parts.find(part => part.type === 'hour').value;
    const minute = parts.find(part => part.type === 'minute').value;

    return `${day} ${month} ${year}, ${hour}:${minute}`; //example: 11 LIS 2026, 12:43
}

export function isSameDay(date1, date2) {
    return date1.getFullYear() === date2.getFullYear() 
        && date1.getMonth() === date2.getMonth() 
        && date1.getDate() === date2.getDate();
}

//calculates gap, for example between 2026-04-23 and 2026-04-25 the gap is 1 day
export function getDaysGap(date1, date2) {
    const diffMs = date2 - date1;
    const diffDays = diffMs / (1000 * DATE_CONSTANTS.secondsInDay);
    return diffDays - 1;
}